export const PEOPLE_BY_NAME = 'PEOPLE_BY_NAME';
export const PERSON_BY_ID_NUMBER = 'PERSON_BY_ID_NUMBER';
export const PERSON_BY_ID_USERNAME = 'PERSON_BY_ID_USERNAME';
export const PERSON_BY_ID = 'PERSON_BY_ID';
export const PEOPLE = 'people';
export const PEOPLE_LABEL = 'Individual';
export const ORG_BY_NAME = 'ORG_BY_NAME';
export const ORG_BY_ID_NUMBER = 'ORG_BY_ID_NUMBER';
export const ORG = 'organizations';
export const ORG_LABEL = 'Organization';
// identifiers
export const AUCTION_ACCESS_NUMBER = 'AUCTION_ACCESS_NUMBER';
export const USERNAME = 'USERNAME';
export const MANHEIM_ACCOUNT_NUMBER = 'MANHEIM_ACCOUNT_NUMBER';
export const COMMERCIAL_ACCOUNT = 'COMMERCIAL_ACCOUNT';
export const MEGA_ACCOUNT = 'MEGA_ACCOUNT';
export const CLIENT_ID = 'CLIENT_ID';

export const USERNAME_PREFIX = 'manheim-customer:';

export const SEARCH_NOT_FOUND_MSG =
  'No results found. Please search again. You may edit your search to view more results';
export const NO_RESULTS_FOUND = 'No results found. Please try searching with another search term.'
export const NO_ACTIVE_RESULTS_FOUND = 'No active results found. Please refine your search or turn on inactive results.'
export const typeSearchDropdown = [
  {
    value: PEOPLE,
    id: 1,
    name: PEOPLE_LABEL,
  },
  {
    value: ORG,
    id: 2,
    name: ORG_LABEL,
  },
];
